module.exports = __webpack_public_path__ + "img/avatar.9c53fbea.png";